import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
  Input,
  ViewEncapsulation,
} from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { PatientService } from "../../patients.service";
import { MyErrorStateMatcher } from "../../../shared/components/MyErrorStateMatcher/MyErrorStateMatcher.component";
import { Patient, PatientMinimum } from "../../../core/model/patient";
import { PhysicianOptionService } from "src/app/physician/shared/physician-option/physician-option.service";

@Component({
  selector: "app-patient-new-minumum",
  templateUrl: "./patient-new-minumum.component.html",
  styleUrls: ["./patient-new-minumum.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PatientNewMinumumComponent implements OnInit {
  constructor(
    private patientsService: PatientService,
    private physicianOptionService: PhysicianOptionService
  ) {}

  @Input() specialistId: number;
  @Output() save: EventEmitter<Patient> = new EventEmitter();
  @ViewChild("fileInput", { static: true }) fileInput;
  @ViewChild("fileInput2", { static: true }) fileInput2;

  patientCreated: boolean;
  patient: PatientMinimum;
  createdPatient: any;
  errorUnverifiedNumber: boolean = false;
  maxDate: Date = new Date();

  matcher = new MyErrorStateMatcher();

  firstNameFormControl = new FormControl("", [Validators.required]);
  middleNameFormControl = new FormControl("", []);
  lastNameFormControl = new FormControl("", [Validators.required]);
  preferredNameFormControl = new FormControl("", []);
  emailFormControl = new FormControl("", [
    Validators.required,
    Validators.email,
  ]);
  mobileContactNumberFormControl = new FormControl("", [Validators.required]);
  workContactNumberFormControl = new FormControl("", []);
  genderFormControl = new FormControl("", [Validators.required]);
  dobFormControl = new FormControl("", [Validators.required]);

  dataForm: FormGroup = new FormGroup({
    firstname: this.firstNameFormControl,
    middlename: this.middleNameFormControl,
    lastname: this.lastNameFormControl,
    email: this.emailFormControl,
    gender: this.genderFormControl,
    dob: this.dobFormControl,
    phone: this.mobileContactNumberFormControl,
    secphone: this.workContactNumberFormControl,
  });

  ngOnInit() {
    this.patient = <PatientMinimum>{};
  }

  onNoClick(): void {}

  onSubmit(patient: PatientMinimum): void {
    if (this.dataForm.invalid) {
      return;
    }

    patient.practitionerId = this.physicianOptionService.getPhysician().id;

    this.patientsService.createMinimumnPatient(patient).subscribe(
      (p) => {
        this.createdPatient = p;
        this.patientCreated = true;
        this.save.emit(p);
      },
      (error) => {
        console.error(error);
        if (error.error === 21608) {
          this.patientCreated = true;
          this.errorUnverifiedNumber = true;
        } else {
          return;
        }
      }
    );
  }

  cancel() {
    this.patientCreated = false;
    this.save.emit(null);
  }
}
